/**
 * Должен совпадать с backend/config/userRoles.js (данные из shared/userRoles.json).
 */

import manifest from '../../../shared/userRoles.json';

export const ROLE_ADMIN = manifest.ROLE_ADMIN;
export const ROLE_USER = manifest.ROLE_USER;
export const ROLE_MANAGER = manifest.ROLE_MANAGER;
export const ROLE_SUPPORT = manifest.ROLE_SUPPORT;

export const STAFF_ROLES = Object.freeze([...manifest.STAFF_ROLES]);
export const APP_USER_ROLES = Object.freeze([...manifest.APP_USER_ROLES]);
export const ADMIN_OR_MANAGER_ROLES = Object.freeze([...manifest.ADMIN_OR_MANAGER_ROLES]);

export function normalizeRole(role) {
  return role == null ? '' : String(role).toLowerCase();
}

export function hasStaffRole(role) {
  return STAFF_ROLES.includes(normalizeRole(role));
}

export function isValidAppUserRole(role) {
  return APP_USER_ROLES.includes(normalizeRole(role));
}

export function isAdminRole(role) {
  return normalizeRole(role) === ROLE_ADMIN;
}

export function isManagerRole(role) {
  return normalizeRole(role) === ROLE_MANAGER;
}

export function isAdminOrManagerRole(role) {
  const r = normalizeRole(role);
  return r === ROLE_ADMIN || r === ROLE_MANAGER;
}

/** Обычный клиентский аккаунт (не staff). */
export function isEndUserRole(role) {
  return normalizeRole(role) === ROLE_USER;
}

/** BulkGate rates, platform margin — only for staff (admin, manager, support). */
export function canSeeSmsProviderPricing(role) {
  if (!role) return false;
  return !isEndUserRole(role);
}
